import { useLocale } from "../../i18n/LocaleProvider";
import { ChevronRightIcon } from "../../components/skills/icons";
import type { EndReportRecord } from "../../../../shared/end-report";
import { StatusBadge } from "./EndReportPanel";
import "./end-report.css";

/**
 * The latest round under the transcript, in the Save Skill card's frame: one
 * row that opens the side panel. The caption carries the round and the whole
 * work's status; the title and bullets are what this round produced.
 */
export function EndReportCard({ record, sent, onOpen }: { record: EndReportRecord; sent: boolean; onOpen: () => void }) {
  const { t } = useLocale();
  return <div className="save-skill-card end-report-card">
    <button type="button" className="save-skill-card-row" onClick={onOpen} aria-label={t("endReport.view")}>
      <span className="end-report-card-text">
        <span className="end-report-card-caption">
          <span>{t("endReport.title")} · {t("endReport.round", { round: record.round })}</span>
          {sent ? <span className="end-report-sent">{t("workSettings.submitted")}</span> : <StatusBadge status={record.report.work.status} />}
        </span>
        <span className="save-skill-card-title">{record.report.current.title}</span>
        <ul className="end-report-card-results">
          {record.report.current.results.map((result, i) => <li key={i}><span title={result}>{result}</span></li>)}
        </ul>
      </span>
      <span className="save-skill-card-chevron" aria-hidden="true"><ChevronRightIcon size={16} /></span>
    </button>
  </div>;
}
